import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  async getStockcars(params) {
    try {
      const response = await axios.get('getstockcars', { params })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getReservationInfo(stockCarId) {
    try {
      const response = await axios.get(`GetStockCarReservationInfo?id=${stockCarId}`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getStockCarIdFromCommissionNumber(commissionNumber) {
    try {
      const response = await axios.get(
        `GetStockCarIdFromCommissionNumber?commissionNumber=${commissionNumber}`
      )
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getStockIdFromCommissionNumber(commissionNumber) {
    try {
      const response = await passThroughAxios.get('stockcarsNew/stockId', {
        params: { commissionNumber },
      })
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  async setStockCarReservation(params) {
    try {
      let { stockCarId, quoteId, establishmentId } = params
      const response = await axios.put(
        `StockCarSetReservation/${stockCarId}?quoteId=${quoteId}&establishmentId=${establishmentId}`
      )
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
